// @ts-nocheck


import queryString from 'query-string';


import {
  fetchRequest,
  downloadRequestWithToken,
  initialFetchListParams } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as actConvertDataFromServer } from './act';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';


export const convertDataFromServer = (inspectionGtn) => ({
  ...inspectionGtn,
  price: convertFromKopToRub(inspectionGtn.price),
  taxPrice: convertFromKopToRub(inspectionGtn.taxPrice),
  totalPrice: convertFromKopToRub(inspectionGtn.totalPrice),
  act: inspectionGtn.act ?
  actConvertDataFromServer(inspectionGtn.act) :
  undefined
});

export const convertDataToServer = (inspectionGtn) => ({
  ...inspectionGtn,
  price: convertFromRubToKop(inspectionGtn.price),
  taxPrice: convertFromRubToKop(inspectionGtn.taxPrice),
  totalPrice: convertFromRubToKop(inspectionGtn.totalPrice)
});

export const addInspectionGtn = async (
inspectionGtn) =>
{
  const added = await fetchRequest.post(
    '/inspectionGtn',
    convertDataToServer(inspectionGtn)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать технический осмотр ГТН');
};

export const updateInspectionGtn = async (
inspectionGtn) =>
{
  const updated = await fetchRequest.put(
    '/inspectionGtn',
    convertDataToServer(inspectionGtn)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить технический осмотр ГТН');
};
export const deleteInspectionGtn = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/inspectionGtn/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить технический осмотр ГТН');
};

export const fetchInspectionGtn = async (
id,
params = {}) =>
{
  const inspectionGtn = await fetchRequest.get(`/inspectionGtn/${id}`, params);
  if (inspectionGtn) return convertDataFromServer(inspectionGtn);
  throw new Error('Не удалось получить технический осмотр ГТН');
};

export const fetchVehicleInspectionsGtn = async (
vehicleId,
params = initialFetchListParams) =>
{
  const inspectionGtnes = await fetchRequest.get(
    `/inspectionGtn/vehicle/${vehicleId}`,
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (inspectionGtnes) {
    return {
      ...inspectionGtnes,
      data: inspectionGtnes.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось список технических осмотров ГТН');
};

export const fetchInspectionsGtn = async (
params = initialFetchListParams) =>
{
  const inspectionsGtn = await fetchRequest.get('/inspectionGtn', {
    ...initialFetchListParams,
    ...params
  });
  if (inspectionsGtn) {
    return {
      ...inspectionsGtn,
      data: inspectionsGtn.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список технических осмотров ГТН');
};

export const updateAct = async (
params,
data) =>
{
  const expertiseServiceGpm = await fetchRequest.put(
    `/inspectionGtn/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (expertiseServiceGpm) {
    return {
      ...expertiseServiceGpm,
      data: expertiseServiceGpm.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось закрепить акт за т.о. ГТН');
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/inspectionGtn/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(`/inspectionGtn/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(
    `/inspectionGtn/groupedList`,
    params
  );
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export default {
  groupedList,
  getTotalSum,
  printReport,
  updateAct,
  addInspectionGtn,
  updateInspectionGtn,
  deleteInspectionGtn,
  fetchInspectionGtn,
  fetchVehicleInspectionsGtn,
  fetchInspectionsGtn
};
